// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"e329f2c0","404":"4a754aa7"}[chunkId] + ".chunk.js";
};